export default "__VITE_ASSET__Bbg8lueO__"